// The one upload card behind every spreadsheet import: activity lines,
// onsite requests and the franchisee roster all render this with their own
// copy and request. The server refuses a file whole if any row fails, so the
// card only ever reports a clean landing or the refusal with line numbers.

import { useState } from 'react'
import { Button, FilePicker, Notice, Panel } from './components/ui/index.js'
import { useApiForm } from './useApiForm.js'

export default function ImportCard({
  id,
  title,
  description,
  request,
  describe,
  onImported,
  onClose,
}) {
  const [file, setFile] = useState(null)
  const [outcome, setOutcome] = useState(null)
  const { saving, error, submit } = useApiForm()

  async function run() {
    if (!file) return
    const result = await submit(() => request(file))
    if (result) {
      setOutcome(describe(result))
      setFile(null)
      onImported()
    } else {
      setOutcome(null)
    }
  }

  return (
    <Panel title={title} support={description}>
      {error ? <Notice tone="bad">{error}</Notice> : null}
      {outcome && !error ? <Notice tone="ok">{outcome}</Notice> : null}

      <FilePicker id={id} file={file} accept=".csv,.xlsx" onChange={setFile} />

      <div className="btnrow">
        {onClose ? (
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        ) : null}
        <span className="spacer" />
        <Button variant="primary" onClick={run} disabled={saving || !file}>
          {saving ? 'Importing' : 'Import'}
        </Button>
      </div>
    </Panel>
  )
}
